import { parseISO } from "date-fns";

import Highlight from "@/components/Highlight";
import { DATE_FORMAT, SOURCE, Source, TEXT } from "@/constants";
import { useMentionCard } from "@/containers/MentionCard/context";
import Insights from "@/containers/MentionCard/partials/Insights";
import PopularityScore from "@/containers/MentionCard/partials/PopularityScore";
import PRValue from "@/containers/MentionCard/partials/PRValue";
import Reach from "@/containers/MentionCard/partials/Reach";
import Toplist from "@/containers/MentionCard/partials/Toplist";
import TranscriptStatus from "@/containers/MentionCard/partials/TranscriptStatus";
import { useI18n } from "@/contexts/i18nContext";
import { cx } from "@/utils";

import EpisodeSentiment from "../Sentiment";
import Tags from "../Tags";

import styles from "./Footer.module.css";

const TIME_SENSITIVE_MEDIA: Source[] = [SOURCE.RADIO, SOURCE.TV];

const Footer: React.FunctionComponent<{ className?: string }> = ({
  className,
  ...props
}) => {
  const {
    channel: { channel_type },
    episode: { published_date },
    hideReach,
    hidePrValue,
    hideSentiment,
    hideTags,
  } = useMentionCard();
  const is_text_source = TEXT.includes(channel_type);
  const { formatDate } = useI18n();

  // Radio/TV sources should display the time as well as the date
  const datePrecision = TIME_SENSITIVE_MEDIA.includes(channel_type)
    ? DATE_FORMAT.LONG_WITH_TIME
    : DATE_FORMAT.LONG;

  const formattedPublishDate = formatDate(
    parseISO(published_date),
    datePrecision
  );

  return (
    <>
      <div className={cx(styles.root, className)} {...props}>
        <Highlight label={formattedPublishDate} />
        {!is_text_source && <TranscriptStatus />}
        <Insights />
        <Toplist />
        {!hideReach && <Reach />}
        {!hidePrValue && <PRValue />}
        <PopularityScore />
        {!hideSentiment && <EpisodeSentiment />}

        {!hideTags && <Tags />}
      </div>
    </>
  );
};

export default Footer;
